module.exports = __webpack_public_path__ + "img/qq.8968a17d.svg";